/*
 *  Email validation
 */
export const isValidEmail = (email: string): boolean => {
  const emailFormatted = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/
  return emailFormatted.test(email)
}

/*
 *  Zipcode validation
 */
export const isValidZipcode = (zip: string | number): boolean => {
  const zipFormatted = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  return zipFormatted.test(String(zip))
}

/*
 * Phone number Validation
 * @param input - the phone number string to validate
 * @param optional - when true, empty/missing input is considered valid
 */
export const isValidPhoneNumber = (
  input: string | undefined | null,
  optional = true
): boolean => {
  const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
  if (optional && (input?.trim() === '' || !input)) {
    return true
  }
  return phoneRegex.test(input ?? '')
}

/** Utility function to format phone numbers */
export const formatPhoneNumber = (input: string | number): string => {
  let formattedInput = ''
  const receivedInput = String(input)
  if (receivedInput) {
    formattedInput = receivedInput
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
  return formattedInput
}

export const formatPhoneNumberForAriaLabel = (tel: string): string => {
  let label = ''
  if (tel) {
    // Remove `tel:` protocol, insert spaces between the numbers
    const digits = tel.split('tel:')[1].split('').join(' ')
    // Group the numbers, insert periods
    label = `${digits.slice(0, 5)}.${digits.slice(5, 11)}.${digits.slice(11)}`
  }
  return label
}

export const debounce = <T extends unknown[]>(
  func: (...args: T) => void,
  delay: number
): ((...args: T) => void) => {
  let timeout: ReturnType<typeof setTimeout> | undefined
  return (...args: T) => {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), delay)
  }
}
